import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { CheckCircle } from 'lucide-react';
import { COLORS } from '../constants';
import Button from '../components/Button';
import SectionHeading from '../components/SectionHeading';
import { startCheckout } from "../utils/checkout";



const QuotePage = () => {
  const defaultModel = window.selectedModel || "";
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    cityState: "",
    zip: "",
     model: defaultModel,
    purchaseType: "Personal Use",
    accessories: "Standard Package",
    comments: ""
  });

  const [status, setStatus] = useState("idle");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (

    <section className="py-24 min-h-screen" style={{ backgroundColor: COLORS.lightSurface }}>
	<Helmet>
  <title>Request a Quote for Electric Golf Scooters | Lectric Leisure</title>
  <link rel="canonical" href="https://lectricleisure.golf/quote" />
  <meta
    name="description"
    content="Request a personalized quote for Lectric Leisure electric golf scooters and accessories."
  />
</Helmet>
      <div className="container mx-auto px-6 max-w-5xl">
        <SectionHeading
          title="Extras, Spares & Special Orders"
          subtitle="Looking for spare parts, bulk fleet pricing, or premium extras? Tell us what you need and we'll get back to you with pricing."
        />

        <div className="bg-white rounded-[3rem] shadow-2xl overflow-hidden border border-[#E0D8C8]">
          <div className="p-12">

            {status === "success" ? (
              <div className="text-center py-20">
                <CheckCircle size={64} className="mx-auto mb-6 text-[#C7A36A]" />
                <h2 className="text-3xl text-[#1E1E1C] font-serif font-bold mb-4">
                  Request Received
                </h2>
                <p className="text-lg text-[#1E1E1C] opacity-80">
                  Our team will contact you shortly with the requested information and pricing.
                </p>
              </div>
            ) : (

              <form
  onSubmit={async (e) => {
    e.preventDefault();
    setStatus("submitting");

    try {
      const res = await fetch("https://formspree.io/f/xaqnrdke", {
        method: "POST",
        headers: { "Accept": "application/json" },
        body: new FormData(e.target),
      });

      if (res.ok) setStatus("success");
      else setStatus("error");
    } catch {
      setStatus("error");
    }
  }}
  className="space-y-8"
>
                <div className="grid md:grid-cols-2 gap-8">
                  <div>
                    <label className="block text-sm font-extrabold mb-3 uppercase tracking-widest text-[#1E1E1C]">
                      First Name
                    </label>
                    <input
                      required
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      className="w-full p-5 rounded-2xl bg-[#F9F7F2] border-2 border-[#E0D8C8] font-bold text-[#1E1E1C]"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-extrabold mb-3 uppercase tracking-widest text-[#1E1E1C]">
                      Last Name
                    </label>
                    <input
                      required
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      className="w-full p-5 rounded-2xl bg-[#F9F7F2] border-2 border-[#E0D8C8] font-bold text-[#1E1E1C]"
                    />
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-8">
                  <div>
                    <label className="block text-sm font-extrabold mb-3 uppercase tracking-widest text-[#1E1E1C]">
                      Email Address
                    </label>
                    <input
                      required
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full p-5 rounded-2xl bg-[#F9F7F2] border-2 border-[#E0D8C8] font-bold text-[#1E1E1C]"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-extrabold mb-3 uppercase tracking-widest text-[#1E1E1C]">
                      Phone Number
                    </label>
                    <input
                      required
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full p-5 rounded-2xl bg-[#F9F7F2] border-2 border-[#E0D8C8] font-bold text-[#1E1E1C]"
                    />
                  </div>
                </div>

                <div className="grid md:grid-cols-3 gap-8">
                  <div className="md:col-span-2">
                    <label className="block text-sm font-extrabold mb-3 uppercase tracking-widest text-[#1E1E1C]">
                      Shipping City & State
                    </label>
                    <input
                      required
                      name="cityState"
                      value={formData.cityState}
                      onChange={handleChange}
                      className="w-full p-5 rounded-2xl bg-[#F9F7F2] border-2 border-[#E0D8C8] font-bold text-[#1E1E1C]"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-extrabold mb-3 uppercase tracking-widest text-[#1E1E1C]">
                      Zip Code
                    </label>
                    <input
                      required
                      name="zip"
                      value={formData.zip}
                      onChange={handleChange}
                      className="w-full p-5 rounded-2xl bg-[#F9F7F2] border-2 border-[#E0D8C8] font-bold text-[#1E1E1C]"
                    />
                  </div>
                </div>

                <div className="pt-6 border-t border-[#E0D8C8]">
                  <label className="block text-sm font-extrabold mb-6 uppercase tracking-widest text-lg text-[#1E1E1C]">
                    Select Your Model (If applicable)
                  </label>

                  <div className="grid md:grid-cols-3 gap-6">
                    {["M12-1", "M12-3", "ESGOLF"].map(model => (
                      <label key={model} className="cursor-pointer">
                        <input
  			   type="radio"
  			   name="model"
  			   value={model}
  			   required={false}
  			   checked={formData.model === model}
  			   onChange={handleChange}
  			   className="peer sr-only"
			/>
                        <div className="p-6 rounded-2xl border-2 border-[#E0D8C8] peer-checked:border-[#C7A36A] peer-checked:bg-[#C7A36A]/10 text-center text-[#1E1E1C]">
                          <span className="font-bold text-lg">{model}</span>
                        </div>
                      </label>
                    ))}
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-8">
                  <div>
                    <label className="block text-sm font-extrabold mb-3 uppercase tracking-widest text-[#1E1E1C]">
                      Order / Inquiry Type
                    </label>
                    <select
                      name="purchaseType"
                      value={formData.purchaseType}
                      onChange={handleChange}
                      className="w-full p-5 rounded-2xl bg-[#F9F7F2] border-2 border-[#E0D8C8] font-bold text-[#1E1E1C]"
                    >
                      <option>Premium Extras / Upgrades</option>
                      <option>Spare Parts & Maintenance</option>
                      <option>Bulk / Fleet Order Inquiry</option>
                      <option>Personal Use Quote</option>
                      <option>Reseller Inquiry</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-extrabold mb-3 uppercase tracking-widest text-[#1E1E1C]">
                      Primary Interest
                    </label>
                    <select
                      name="accessories"
                      value={formData.accessories}
                      onChange={handleChange}
                      className="w-full p-5 rounded-2xl bg-[#F9F7F2] border-2 border-[#E0D8C8] font-bold text-[#1E1E1C]"
                    >
                      <option>Standard Package</option>
                      <option>Spare Batteries</option>
                      <option>Rain Covers / Storage</option>
                      <option>Custom Seats / Comfort</option>
                      <option>Tyres & Mechanical Parts</option>
                      <option>All Accessories</option>
                    </select>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-extrabold mb-3 uppercase tracking-widest text-[#1E1E1C]">
                    Details of your request
                  </label>
                  <textarea
                    rows="4"
                    name="comments"
                    placeholder="Please specify parts, quantities, or custom requirements..."
                    value={formData.comments}
                    onChange={handleChange}
                    className="w-full p-5 rounded-2xl bg-[#F9F7F2] border-2 border-[#E0D8C8] font-bold text-[#1E1E1C]"
                  />
                </div>

                <Button
                  type="submit"
                  disabled={status === "submitting"}
                  className="w-full py-6 text-2xl"
                >
                  {status === "submitting" ? "Submitting Request..." : "Submit Special Order Request"}
                </Button>
              </form>
		
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuotePage;